exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-symbols-outlined[data-v-bdd99a60] {\n  font-variation-settings: \"FILL\" 1, \"wght\" 400, \"GRAD\" 0, \"opsz\" 24;\n}\n.overflow-auto[data-v-bdd99a60] {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n  /* Hide scrollbar for Chrome, Safari and Opera */\n}\n.overflow-auto[data-v-bdd99a60]::-webkit-scrollbar {\n  display: none;\n}\n.slick-slider-carousel[data-v-bdd99a60]  .slick-slide {\n  padding: 0;\n}", ""]);

// exports
